import React from 'react';
import { useTranslation } from 'react-i18next';
import ServicePageLayout from '../../component/common/servicesPagesLayout';

const DesigningPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '🎨',
      title: t('designing.features.1.title'),
      description: t('designing.features.1.desc'),
    },
    {
      icon: '🖥️',
      title: t('designing.features.2.title'),
      description: t('designing.features.2.desc'),
    },
    {
      icon: '📱',
      title: t('designing.features.3.title'),
      description: t('designing.features.3.desc'),
    },
    {
      icon: '✉️',
      title: t('designing.features.4.title'),
      description: t('designing.features.4.desc'),
    },
    {
      icon: '✨',
      title: t('designing.features.5.title'),
      description: t('designing.features.5.desc'),
    },
    {
      icon: '📐',
      title: t('designing.features.6.title'),
      description: t('designing.features.6.desc'),
    },
  ];

  const process = [
    { title: t('designing.process.1.title'), description: t('designing.process.1.desc') },
    { title: t('designing.process.2.title'), description: t('designing.process.2.desc') },
    { title: t('designing.process.3.title'), description: t('designing.process.3.desc') },
    { title: t('designing.process.4.title'), description: t('designing.process.4.desc') },
  ];

  const whyChooseUs = [
    { stat: '40+', label: t('designing.why.1.label') },
    { stat: '100%', label: t('designing.why.2.label') },
    { stat: '2-6', label: t('designing.why.3.label') },
    { stat: '∞', label: t('designing.why.4.label') },
  ];

  const techStack = [
    { icon: '🎨', name: 'Figma' },
    { icon: '📐', name: 'Adobe XD' },
    { icon: '✏️', name: 'Sketch' },
    { icon: '🖼️', name: 'Photoshop' },
    { icon: '📸', name: 'Illustrator' },
    { icon: '🎬', name: 'After Effects' },
    { icon: '📊', name: 'Canva' },
    { icon: '🔤', name: 'Google Fonts' },
    { icon: '🎭', name: 'Lottie' },
    { icon: '📏', name: 'Zeplin' },
  ];

  const faqs = [
    {
      question: t('designing.faq.q1'),
      answer: t('designing.faq.a1'),
    },
    {
      question: t('designing.faq.q2'),
      answer: t('designing.faq.a2'),
    },
    {
      question: t('designing.faq.q3'),
      answer: t('designing.faq.a3'),
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'UI/UX Design Services',
    provider: {
      '@type': 'Organization',
      name: 'BringIt Go',
      url: 'https://www.bringitgo.tech',
    },
    description: 'Professional UI/UX design services — website design, mobile app design, brand identity, email templates, and design systems.',
    url: 'https://www.bringitgo.tech/designing',
    areaServed: 'Worldwide',
    serviceType: 'UI/UX Design',
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <ServicePageLayout
      accentClass="service-accent-design"
      badge={t('designing.badge')}
      title={t('designing.heroTitle')}
      description={t('designing.heroDescription')}
      features={features}
      process={process}
      whyChooseUs={whyChooseUs}
      techStack={techStack}
      faqs={faqs}
      seo={{
        title: t('designing.seo.title'),
        description: t('designing.seo.description'),
        canonical: 'https://www.bringitgo.tech/designing',
      }}
      structuredData={[structuredData, faqStructuredData]}
    />
  );
};

export default DesigningPage;
